import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircle, X, Lightbulb, Layers, Palette, Maximize2, WifiOff } from 'lucide-react';
export function DesignNotes() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <button onClick={() => setIsOpen(true)} className="fixed top-20 right-6 z-40 bg-slate-800 hover:bg-slate-700 text-slate-300 p-2.5 rounded-full shadow-lg border border-slate-700 transition-colors" title="Design Notes" data-id="element-119">
        <HelpCircle className="w-5 h-5" data-id="element-120" />
      </button>

      <AnimatePresence data-id="element-121">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsOpen(false)} className="fixed inset-0 bg-slate-950/60 backdrop-blur-sm z-50" data-id="element-122" />
            <motion.div initial={{
          opacity: 0,
          x: 300,
          scale: 0.95
        }} animate={{
          opacity: 1,
          x: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          x: 300,
          scale: 0.95
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed top-4 bottom-4 right-4 w-[400px] glass-panel rounded-2xl z-50 flex flex-col shadow-2xl border-slate-700 overflow-hidden" data-id="element-123">
              <div className="p-5 border-b border-slate-800 flex justify-between items-center bg-slate-900/80" data-id="element-124">
                <h2 className="text-lg font-bold text-slate-100 flex items-center gap-2" data-id="element-125">
                  <Lightbulb className="w-5 h-5 text-brand-amber" data-id="element-126" />
                  Design Decisions
                </h2>
                <button onClick={() => setIsOpen(false)} className="text-slate-400 hover:text-white transition-colors" data-id="element-127">
                  <X className="w-5 h-5" data-id="element-128" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-5 space-y-6 scrollbar-hide" data-id="element-129">
                <NoteSection icon={<Layers className="w-5 h-5 text-brand-blue" data-id="element-131" />} title="Exception-First Hierarchy" content="Instead of a massive table of 50 trucks, the UI leads with an Alert Feed. Dispatchers don't need to see trucks that are on time; they need to manage exceptions. The layout flows Left (Problem) → Center (Context) → Right (Action)." data-id="element-130" />

                <NoteSection icon={<Palette className="w-5 h-5 text-brand-green" data-id="element-133" />} title="Semantic Color System" content="Colors are strictly functional, not decorative. Red = Critical/Action Required Now. Amber = Warning/Action Required Soon. Blue = Info. Green = On Track. Gray = Offline/Unknown. Dark mode reduces eye strain during 12-hour shifts." data-id="element-132" />

                <NoteSection icon={<Maximize2 className="w-5 h-5 text-brand-amber" data-id="element-135" />} title="Scalability (50 → 500 Trucks)" content="As the fleet grows, the map would introduce clustering. The Alert Feed would require ML-based prioritization and grouping (e.g., '3 delays on I-45'). The top KPIs remain the same, providing a high-level pulse regardless of scale." data-id="element-134" />

                <NoteSection icon={<WifiOff className="w-5 h-5 text-slate-400" data-id="element-137" />} title="Handling Real-World Friction" content="Data latency is handled gracefully. When a truck goes offline, it turns gray, ETAs become '~Estimated', and a 'Data Stale' badge appears. This prevents dispatchers from making decisions on outdated information." data-id="element-136" />
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}
function NoteSection({
  icon,
  title,
  content
}: any) {
  return <div data-id="element-138">
      <div className="flex items-center gap-2 mb-2" data-id="element-139">
        {icon}
        <h3 className="font-semibold text-slate-200" data-id="element-140">{title}</h3>
      </div>
      <p className="text-sm text-slate-400 leading-relaxed pl-7" data-id="element-141">{content}</p>
    </div>;
}